import { render, staticRenderFns } from "./Logmanagement.vue?vue&type=template&id=d082308a&scoped=true"
import script from "./Logmanagement.vue?vue&type=script&lang=js"
export * from "./Logmanagement.vue?vue&type=script&lang=js"
import style0 from "./Logmanagement.vue?vue&type=style&index=0&id=d082308a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d082308a",
  null
  
)

export default component.exports